import { render } from "./Android.vue?vue&type=template&id=24a1f566"
import script from "./Android.vue?vue&type=script&lang=js"
export * from "./Android.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/docker/vpn/odessa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__